import Tab from "components/Tab";
import Frameworks from "../../../../contents/docs/integrate/_snippets/frameworks.mdx";
import APIFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-api.mdx";
import WebFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-web.mdx";
import ReactFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-react.mdx";
import NodeFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-node.mdx";
import PythonFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-python.mdx";
import PHPFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-php.mdx";
import RubyFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-ruby.mdx";
import GoFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-go.mdx";
import ReactNativeFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-react-native.mdx";
import AndroidFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-android.mdx";
import IOSFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-ios.mdx";
import FlutterFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-flutter.mdx";
import * as React from 'react';
export default {
  Tab,
  Frameworks,
  APIFeatureFlagsCode,
  WebFeatureFlagsCode,
  ReactFeatureFlagsCode,
  NodeFeatureFlagsCode,
  PythonFeatureFlagsCode,
  PHPFeatureFlagsCode,
  RubyFeatureFlagsCode,
  GoFeatureFlagsCode,
  ReactNativeFeatureFlagsCode,
  AndroidFeatureFlagsCode,
  IOSFeatureFlagsCode,
  FlutterFeatureFlagsCode,
  React
};